<template>

<div class="panel" :class="{'is-padded': isPadded}">

    <div class="panel-head" v-if="title || tabs || button || hasToggle">

        <div class="panel-head-title" v-if="title">{{ title }}</div>

        <div class="panel-head-tabs" v-if="tabs">

            <div class="panel-head-tabs-item" :class="{'is-active': currentTab === index}" v-for="(tab, index) in tabs" :key="index" v-on:click="onTabClick(index)">

                {{ tab }}

            </div>

        </div>

        <div class="panel-head-button" v-if="button">

            <app-button theme="white" :text="button" class="panel-head-button-item" v-on:click.native="$emit('button')" />
        
        </div>

        <div class="panel-head-toggle" v-if="hasToggle">

            <div class="panel-head-toggle-text">{{ hasToggle }}</div>
            <div class="panel-head-toggle-box" :class="{'is-active': toggled}" v-on:click="onToggleClick">&#10003;</div>
        
        </div>

    </div>

    <div class="panel-body" v-if="!isLoading && !isEmpty && !isCollapsed">

        <template v-if="tabs">

            <template v-for="(tabText, tabKey) in tabs">

                <slot :name="tabKey" v-if="currentTab === tabKey">

                </slot>

            </template>

        </template>

        <slot></slot>

    </div>

    <div class="panel-loading" v-if="isLoading">

        Loading, please wait...

    </div>

    <div class="panel-empty" v-if="isEmpty && !isLoading">

        {{ emptyMessage || 'None found.' }}

    </div>

</div>

</template>

<script>

export default {

    props: ['title', 'isLoading', 'isEmpty', 'button', 'isCollapsed', 'tabs', 'toggled', 'hasToggle', 'isPadded', 'emptyMessage'],

    data: function() {
        
        return {
            currentTab: ''
        }

    },

    created: function() {

        if (this.tabs) {
        
            this.currentTab = this.$_.keys(this.tabs)[0]
        
        }
    
    },

    methods: {
    
        onToggleClick: function() {
    
            this.$emit('toggle', !this.toggled)
        
        },

        onTabClick: function(value) {
        
            this.currentTab = value

            this.$emit('tab', value)
        
        }
    
    }

}

</script>

<style scoped>

.panel {
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 40px;
}

.panel:last-child {
    margin-bottom: 0px;
}

.panel-head {
    background-color: #005EB8;
    color: #fff;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 3px 6px #00000029;
}

.panel-head-title {
    font-size: 16px;
    padding: 0px 40px;
    font-weight: 600;
}

.panel-head-tabs {
    flex-grow: 1;
    display: flex;
}

.panel-head-tabs-item {
    flex-grow: 1;
    flex-shrink: 0;
    text-align: center;
    color: #A2C2E6;
    height: 64px;
    font-size: 14px;
    line-height: 64px;
    cursor: pointer;
    font-weight: 500;
    border-bottom: 4px solid transparent;
}

.panel-head-tabs-item:hover {
    background-color: #044b8f;
    color: #fff;
    border-bottom: 4px solid #A2C2E6;
}

.panel-head-tabs-item.is-active {
    color: #fff;
    border-color: #fff;
}

.panel-head-toggle {
    display: flex;
    padding: 0px 40px;
    align-items: center;
}

.panel-head-toggle-box {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    width: 24px;
    height: 24px;
    margin-left: 10px;
    user-select: none;
    cursor: pointer;
    color: #ccc;
    line-height: 24px;
    text-align: center;
}

.panel-head-toggle-box:hover {
    background-color: #eee;
    color: #999;
}

.panel-head-toggle-box.is-active {
    background-color: #fff;
    color: #005EB8;
}

.panel-head-toggle-text {
    font-size: 14px;
    color: #fff;
    font-weight: 400;
}

.panel-head-button {
    padding-right: 40px;
}

.panel-head-button-item {
    height: 40px;
    font-weight: 500;
    line-height: 40px;
    border-radius: 20px;
    padding: 0px 20px;
}

.panel-empty,
.panel-loading {
    height: 120px;
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #666;
    align-items: center;
}

.panel.is-padded .panel-body {
    padding: 20px;
}

</style>
